import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../services/AuthContext";
import { getSubscriptionPlans, saveUserSelectedPlan } from '../data/db';
import {
  ButtonPrimary,
  ButtonSunshine,
  Card,
  StatCard,
  Badge,
  Icon,
  FeatureIcon
} from '../components/ComponentLibrary';
import ScrollReveal from '../components/ScrollReveal';
import './DashboardNew.css';

export default function Dashboard() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    const dbPlans = getSubscriptionPlans();
    setPlans(dbPlans);
  }, []);

  function choosePlan(planId) {
    if (!user) {
      navigate("/login", {
        state: { message: "⛔ من فضلك سجل دخولك أولاً قبل الاشتراك." }
      });
      return;
    }
    saveUserSelectedPlan(user.id || 'child-1', planId);
    navigate('/checkout');
  }

  return (
    <div className="pricing-page">
      {/* 1. Header Section */}
      <ScrollReveal direction="down" duration={0.8}>
        <header className="pricing-header">
          <div className="header-badge">
            <Icon name="sparkles" size={18} className="badge-icon" />
            <span className="badge-text">اختر مسار نجاحك</span>
          </div>
          <h1 className="pricing-title">انطلق في رحلتك مع <span className="highlight">كود ويف</span></h1>
          <p className="pricing-subtitle">
            خطط اشتراك مرنة مصممة لتناسب احتياجات طفلك وتضمن له أفضل تجربة تعليمية.
          </p>
        </header>
      </ScrollReveal>

      {/* 2. Trust Stats Row */}
      <ScrollReveal direction="up" delay={0.2}>
        <div className="trust-stats">
          <StatCard
            title="جلسات مباشرة"
            value="1:1"
            icon="parent"
            variant="ocean"
            description="مع نخبة من المعلمين"
          />
          <StatCard
            title="دروس مسجلة"
            value="50+"
            icon="lessons"
            variant="sky"
            description="متاحة في أي وقت"
          />
          <StatCard
            title="دعم فني"
            value="24/7"
            icon="mail"
            variant="sunshine"
            description="عبر واتساب"
          />
        </div>
      </ScrollReveal>

      {/* 3. Pricing Grid */}
      <section className="plans-section">
        <div className="plans-grid">
          {plans.map((plan, index) => {
            const isAnnual = plan.id === 'plan-annual';
            const planIcon =
              plan.id === 'plan-monthly' ? 'play' :
                plan.id === 'plan-quarter' ? 'rocket' :
                  plan.id === 'plan-6month' ? 'sparkles' : 'achievement';

            const planVariant =
              plan.id === 'plan-monthly' ? 'sky' :
                plan.id === 'plan-quarter' ? 'ocean' :
                  plan.id === 'plan-6month' ? 'sunshine' : 'sun';

            return (
              <ScrollReveal key={plan.id} delay={0.1 * index} direction="up" distance={40}>
                <div className={`plan-card-wrapper ${isAnnual ? 'featured' : ''}`}>
                  {isAnnual && (
                    <div className="featured-badge">
                      <Icon name="streak" size={14} /> الأكثر توفيراً - Best Value
                    </div>
                  )}

                  <Card className="pricing-card">
                    <div className="plan-visual">
                      <FeatureIcon name={planIcon} variant={planVariant} size="lg" priority={isAnnual ? "hero" : "primary"} />
                    </div>

                    <h3 className="plan-name">{plan.name}</h3>

                    <div className="price-area">
                      {isAnnual && <div className="price-discount-badge">وفر 4,500 EGP</div>}
                      {isAnnual && <span className="original-price">18,000 EGP</span>}
                      <div className="price-main">
                        <span className="currency">EGP</span>
                        <span className="amount">{plan.priceLabel.replace(' EGP', '')}</span>
                      </div>
                      <span className="duration-label">
                        عن {plan.durationMonths} شهر{plan.durationMonths > 1 ? 'اً' : ''}
                      </span>
                    </div>

                    <ul className="benefits-list">
                      {plan.benefits && plan.benefits.map((benefit, i) => (
                        <li key={i}>
                          <div className="benefit-check">
                            <Icon name="check" size={10} />
                          </div>
                          <span className="benefit-text">{benefit}</span>
                        </li>
                      ))}
                    </ul>

                    <div className="plan-actions">
                      <ButtonPrimary
                        onClick={() => choosePlan(plan.id)}
                        size="lg"
                        className="plan-main-btn"
                        variant={isAnnual ? 'sunshine' : 'ocean'}
                      >
                        اشترك الآن <Icon name="target" size={20} />
                      </ButtonPrimary>
                      <button className="view-details-btn">عرض تفاصيل الخطة</button>
                    </div>
                  </Card>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </section>

      {/* 4. Bottom Banner */}
      <ScrollReveal direction="up" delay={0.2} distance={20}>
        <div className="trial-banner">
          <div className="banner-content">
            <h3><Icon name="star" size={24} /> هل ما زلت تفكر؟</h3>
            <p>ابدأ بالخطة الشهرية لتجربة المنصة بأمان تلم.</p>
          </div>
          <ButtonSunshine
            onClick={() => choosePlan('plan-monthly')}
            size="lg"
          >
            ابدأ التجربة الآن
          </ButtonSunshine>
        </div>
      </ScrollReveal>
    </div>
  );
}